import {useLocation, useOutlet} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import PageTransition from "./PageTransition";

interface AnimatedOutletProps {
  className?: string;
}

const AnimatedOutlet = ({className = ""}: AnimatedOutletProps) => {
  const location = useLocation();
  const outlet = useOutlet();

  // Disable animation for dashboard routes to keep sidebar static
  // Dashboard pages have their own internal animations via FastAnimatedOutlet
  if (location.pathname.startsWith("/env")) {
    return <div className={className}>{outlet}</div>;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <PageTransition key={location.pathname} className={className}>
        {outlet}
      </PageTransition>
    </AnimatePresence>
  );
};

export default AnimatedOutlet;
